const updates = [
  { date: '07-31', title: '繁花 全集上线', desc: '王家卫导演年代大剧《繁花》全30集高清完整版已上线，沪语版与普通话版同步更新' },
  { date: '07-30', title: '大奉打更人 更新至24集', desc: '古装奇幻大剧最新剧集已同步，许七安朝堂智斗剧情进入高潮阶段' },
  { date: '07-30', title: '平台画质升级完成', desc: '全站视频画质升级至1080P蓝光级别，加载速度提升30%，观影体验全面优化' },
  { date: '07-29', title: '白夜破晓 高分回归', desc: '潘粤明主演悬疑神作《白夜破晓》全新季上线，开播即获9.2分高口碑' },
  { date: '07-28', title: '南来北往 完结撒花', desc: '年代情感大剧《南来北往》全39集完结，豆瓣8.8分收官，口碑收视双丰收' },
  { date: '07-27', title: '长相思 第二季定档', desc: '杨紫主演古装仙侠剧续作确认档期，小草影院将同步更新，敬请期待' },
  { date: '07-26', title: '移动端夜间模式上线', desc: 'APP新增夜间模式与倍速播放功能，深夜追剧更舒适，观影体验再度升级' },
  { date: '07-25', title: '庆余年第二季 全集放送', desc: '张若昀主演权谋大剧全36集一次性上线，无需追更一口气看到大结局' },
  { date: '07-24', title: '狂飙 经典重温专题', desc: '现象级刑侦剧《狂飙》开设经典重温专题页，高清全集随时回看经典场面' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-timer-line"></i>
            最新资讯
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">小草影院最新剧集上线与平台更新动态</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-5 pl-12 md:pl-14">
                {/* Timeline dot */}
                <div className="absolute left-[15px] md:left-[19px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                {/* Date */}
                <div className="absolute left-0 top-0 w-8 md:w-10 text-right text-xs font-bold text-primary-500">
                  {item.date}
                </div>

                {/* Content */}
                <div className="flex-1 pb-4 border-b border-background-200/60">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1.5 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}